module.exports = __webpack_public_path__ + "img/site-delivery-present.a36b938e.svg";